export default "__VITE_ASSET__hRGQSzFM__"